module.exports = __webpack_public_path__ + "static/media/blue-logo.58931e02.png";